import React from 'react';

const LeadershipMetricRow = ({
  label,
  count,
  maxCount,
  color,
  minBarWidth = 8,
  onCountClick,
}) => {
  const widthPercent = Math.max(minBarWidth, Math.round((count / maxCount) * 100));

  return (
    <div className="leadership-metric-row">
      <span className="leadership-metric-label" title={label}>{label}</span>
      <div className="leadership-metric-bar-wrap">
        <div className="leadership-metric-track">
          <div
            className="leadership-metric-fill"
            style={{ width: `${widthPercent}%`, backgroundColor: color }}
          />
        </div>
        {onCountClick ? (
          <button
            type="button"
            className="leadership-count-badge"
            onClick={onCountClick}
            title={`View ${count} projects in PAE Queue`}
            aria-label={`View ${count} projects for ${label}`}
          >
            {count}
          </button>
        ) : (
          <strong className="leadership-metric-value">{count}</strong>
        )}
      </div>
    </div>
  );
};

export default LeadershipMetricRow;
